module.exports = __webpack_public_path__ + "static/media/no-preservatives.9940779a.svg";